import {PriceModel} from './Price.model';
import {ModelContext} from '../../types/app.types';

export class CostModel {
  public price: PriceModel;

  constructor(params: CostModel) {
    this.price = params.price;
  }

  public static fromGQL({convertedAmount, modelContext}: {convertedAmount?: number; modelContext: ModelContext}) {
    return new CostModel({
      price: PriceModel.fromGQL({convertedAmount, modelContext}),
    });
  }
}
